const PREFIX = "wff_shows_cache:";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

const keyFor = (params) => PREFIX + JSON.stringify(params);

export const readShowsCache = (params) => {
  try {
    const raw = localStorage.getItem(keyFor(params));
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (Date.now() - entry.ts > MAX_AGE_MS) {
      localStorage.removeItem(keyFor(params));
      return null;
    }
    return entry;
  } catch {
    return null;
  }
};

export const writeShowsCache = (params, data) => {
  try {
    localStorage.setItem(keyFor(params), JSON.stringify({ ts: Date.now(), shows: data.shows, premium: data.premium }));
  } catch {
    // storage full or unavailable; caching is best-effort
  }
};

export const clearShowsCache = () => {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PREFIX))
    .forEach((k) => localStorage.removeItem(k));
};

export const timeAgo = (ts) => {
  const m = Math.round((Date.now() - ts) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  return `${Math.round(m / 60)} h ago`;
};
